import(/* webpackMode: "eager" */ "D:\\CL_Educate_apps\\cl-verse\\node_modules\\next\\font\\google\\target.css?{\"path\":\"app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "D:\\CL_Educate_apps\\cl-verse\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionUserProvider"] */ "D:\\CL_Educate_apps\\cl-verse\\providers\\session-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "D:\\CL_Educate_apps\\cl-verse\\providers\\theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "D:\\CL_Educate_apps\\cl-verse\\providers\\toast-provider.tsx");
